<template>
  <div :class="altBg" ref="luandaleaks" id="luandaleaks" class="cronus-story-container">

    <div v-if="!shareScene" class="timeline-content">
      <div :key="index" :ref="card.year+'_'+card.chapter+'_'+ index" :id="card.id ? card.id : card.year+'_'+card.chapter+'_'+ index" v-for="(card, index) in data.cards"   class="timeline-content__card-wrapper">
          <card-story :url="urlApp" :chapter="data.chapters[card.chapter]" class="timeline-content__card-container" :card="card" :controller="controller" :elements="loadElements(card)" />
      </div>
    </div>

    <div v-if="shareScene" class="timeline-content card-interactive-wrapper">
      <div :ref="embedCard.id" :id="embedCard.id">
        <card-embed :url="urlApp" :chapter="data.chapters[embedCard.chapter]" class="timeline-content__card-container" :card="embedCard" :controller="controller" :elements="loadElements(embedCard)" />
      </div>
    </div>

    <header-story v-if="!shareScene" :current-chapter="activeChapter" :data="data" :show-menu="showMenu" />

    <div class="open-menu-mobile">
      <h3 @click="showMenu=true" class="title">
        <img class="title" :src="imgIcon('icon-chapters.png')" alt="Chapters Luanda Leaks">
      </h3>
    </div>

    <card-progress :percent="calcWidth" v-if="!shareScene"/>

    <footer-story :card="embedCard" :url="urlApp" v-if="shareScene" />
    
  </div>
</template>

<script>
 
  import { gsap } from 'gsap'
  import * as ScrollMagic from 'scrollmagic'
  
  import footerStory from './footerStory.vue'
  import headerStory from './headerStory.vue'
  import cardProgress from './cardProgress.vue'
  import cardStory from './cardStory.vue'
  import cardEmbed from './cardEmbed.vue'

  export default {
    name: "Cronus",
    components: {
      cardStory,
      headerStory,
      cardProgress,
      footerStory,
      cardEmbed
    },
    props: {
      titleApp: null,      
      position: String
    },
    data () {
      return {
        urlApp: 'https://www.icij.org/investigations/luanda-leaks/from-colonization-to-kleptocracy-a-history-of-angola/',
        width: 0,
        height: 0,
        languageApp: {
          type: String,
          default: 'en'
        },
        altBg: false,
        activeChapter: 0,
        navPosition: 1575,
        anchors: null,
        controller: Object,
        data: Object,
        elements: Object,
        showMenu: true,
        slideScene: String,
        shareScene: Boolean
      }
    },
    beforeMount() {
      this.controller = new ScrollMagic.Controller({container: "#luanda-leaks-container"})
      this.data = require("../data/locale_"+this.languageApp.default+".json")
      this.elements = require("../data/elements.json")

      this.shareScene = this.shareSceneValidation()
      this.slideScene = this.slideSceneValidation()
    },
    mounted() {
      this.create_scene(this.data.cards)
      if(this.slideScene && this.shareScene == false) {
        var target = document.getElementById(this.slideScene)
        if(this.slideScene != 'luandaleaks')
          target.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
      }
    },
    computed: {
      embedCard() {
        const $this = this
        if($this.slideScene) {
          return $this.data['cards'].find(function(item) {
            return item.id == $this.slideScene
          })
        }

        return false
      },
      calcWidth() {
        const height = this.$refs['luandaleaks']
        if(height) {
          const totalHeight = document.body.scrollTop || document.documentElement.scrollTop
          return ((totalHeight / height.clientHeight) * 100) + '%'
        }
        return '0%'
      }
    },
    methods: {
      gtag(){
        //dataLayer.push(arguments)
      },
      shareSceneValidation() {
        if(this.getUrlParams().get('format_story') == 'embed')
          return true
        return false
      },
      slideSceneValidation() {
        if(this.getUrlParams().get('slide_story'))
          return this.getUrlParams().get('slide_story')
        if(this.shareSceneValidation())
          return 'invasiontoindependence'
        return 'luandaleaks'
      },
      imgIcon(icon) {
        if(icon)
          return require(`../assets/${icon}`)
        return false
      },
      loadElements(card) {
        const $this = this
        let elements = []

        if(!card.elements)
          return elements

        card.elements.forEach(function(element) {
          elements.push($this.elements[element])
        })

        return elements
      },
      create_scene(scenes) {
        if(this.shareScene == true || !scenes)
          return false

        scenes.forEach((element, ix) => {
          this.animateElement(element, ix)
        });
      },
      getUrlParams() {
        return (new URL(document.location)).searchParams
      },
      animateElement(obj, ix){

        var $this = this

        obj.name = obj.year + "_" + obj.chapter + "_" + ix
        
        var element = this.$refs[obj.name]

        if(element[0]) {
          var tween = gsap.to(element, {duration: 1})
          $this.addScene(tween, obj, element[0])
        }
      },
      addScene(tween, obj, element) {

        var $this = this;

        obj.options = {
          "triggerElement": element,
          "triggerHook": 0.5
        };

        const scene = new ScrollMagic.Scene(obj.options).setTween(tween);

        this.controller.addScene(scene);

        scene.on("start", function() {
          $this.navPosition = obj.year
          $this.activeChapter = obj.chapter
          $this.showMenu = false
          $this.altBg = obj.style ? obj.style : ''
          $this.gtag('event', 'Scrolling', { 'event_action': 'Luanda Leaks Interactive - ' + obj.id, 'event_category': 'User Scroll' });
        })
      }
    }
  };

</script>

<style lang="scss">

  @import '../styles/cronus.scss';
  @import '../styles/cronus-mobile.scss';

  html {
    scroll-behavior: initial;    
  }

  .card-interactive-wrapper {
    background: #333;
  }

  .cronus-story-container {
    position: relative;
    width: 100%;
    transition: background .35s ease-in-out;

    &.timeline-container {
      top: -100vh;
    }

    &.colonial_uprising {
      background: #fff;
    }

    &.chapter1_light {
      background: #fff8de;
    }

    &.chapter1_dark {
      background: #15101b;
    }

    &.chapter1 {
      background: #fff8de;
    }

    &.alternative {
      background: #15101b;
    }

    &.santospower {
      background: #15101b;
    }

    &.gildedage {
      background: #fff;
    }

    &.shoppingspree {
      background: #fff;
    }
  }

</style>